import { routes } from 'constants/config';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import request from 'utils/request_ajax';

const dataRequest = eventsTab => ({
  type: IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_REQUEST,
  eventsTab,
});

const dataReceive = (payload, eventsTab) => ({
  type: IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_RECEIVE,
  payload,
  eventsTab,
});

const dataFailure = (error, eventsTab) => ({
  type: IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_FAILURE,
  error,
  eventsTab,
});

export const tabSelect = tabIndex => ({
  type: IN_PERSON_TRAINING.EVENTS_DASHBOARD.TAB_SELECT,
  tabIndex,
});

export function requestUpcomingEvents(page) {
  return async dispatch => {
    dispatch(dataRequest('upcomingEvents'));
    try {
      const events = await request.get(
        routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD_TABS.UPCOMING,
        {
          page,
        },
      );
      dispatch(dataReceive(events, 'upcomingEvents'));
    } catch (error) {
      dispatch(dataFailure(error, 'upcomingEvents'));
    }
  };
}

export function requestPastEvents(page) {
  return async dispatch => {
    dispatch(dataRequest('pastEvents'));
    try {
      const events = await request.get(
        routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD_TABS.PAST,
        {
          page,
        },
      );
      dispatch(dataReceive(events, 'pastEvents'));
    } catch (error) {
      dispatch(dataFailure(error, 'pastEvents'));
    }
  };
}

export function requestUpcomingOpenEvents(page) {
  return async dispatch => {
    dispatch(dataRequest('upcomingOpenEvents'));
    try {
      const events = await request.get(
        routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD_TABS.OPEN,
        {
          page,
        },
      );
      dispatch(dataReceive(events, 'upcomingOpenEvents'));
    } catch (error) {
      dispatch(dataFailure(error, 'upcomingOpenEvents'));
    }
  };
}
